import { FC } from 'react';
import { ProductCardComponent, CardType } from '../Molecules';
import { PDPHeaderCardPropsTypes } from './types/propsTypes';
import styles from './PDPHeaderCard.module.scss';

export const PDPHeaderCard: FC<PDPHeaderCardPropsTypes> = ({
  link,
  alt,
  brandName,
  productName,
  productId,
  showZeroAsFree = false,
}: PDPHeaderCardPropsTypes): JSX.Element => (
  <div className={styles['cpw-pdp-header-card-container']}>
    <ProductCardComponent
      link={link}
      alt={alt}
      productId={productId || ''}
      brandName={brandName}
      productName={productName}
      productSize=""
      cardType={CardType.PDPHEADERTYPE}
      derivedAvailabilityStatus=""
      currency={''}
      showLinkForProductCard={false}
      showZeroAsFree={showZeroAsFree}
    />
  </div>
);

export type { PDPHeaderCardPropsTypes };
